export const getTableHeadersOneSampleProportion = (isVariableChosen, isLevelChosen) => {
  let headersList = [];
  if (isLevelChosen) {
    headersList = ['Success Group', ...headersList];
  }
  if (isVariableChosen) {
    headersList = ['Variable', ...headersList];
  }

  return [...headersList, 'n', 'Successes', 'p̂', 'Standard Error'];
};

export const tableHeadersTwoSampleT = ['Variable', 'n', 'Mean', 'Standard Deviation', 'Standard Error'];

export const tableHeadersTwoSampleProportion = isGroupChosen => {
  let headersList = [];
  if (isGroupChosen) {
    headersList = ['Success Group'];
  }
  return ['Variable', ...headersList, 'n', 'Successes', 'p̂', 'Standard Error'];
};

export const tableHeadersForPairedTForTwoGroups =
  ['Variable', 'n', 'Mean', 'Standard Deviation', 'Standard Error'];

export const getTableHeadersForPairedT = (isDataSetAvailable, isVariableChosen) => {
  let headersList = [];
  if (isVariableChosen || isDataSetAvailable) {
    headersList = ['Variable'];
  }

  return [
    ...headersList,
    'n',
    `${isDataSetAvailable ? 'Mean' : 'Mean of Sample Differences'}`,
    `${isDataSetAvailable ? 'Standard Deviation' : 'St. Dev of Sample Differences'}`,
    'Standard Error'
  ];
};
